var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var Modal = require('./modal.jsx');
var modalActions = require('../../../modules/modals/actions/modal');

var InterestedSuccessModal = createReactClass({

    onClose: function() {
        this.props.hideModal();
    },

    render: function() {
        var id = this.props.modal.props.id || 'interestedSuccess';

        return (
            <Modal onClose={this.onClose} id={id}>
                <div className="text">
                    <p><span className="ion-ios-checkmark"></span>You're all set. We will contact you when you match any open clinical trials.</p>
                    <div className="actions">
                        <button className="button primary" onClick={this.onClose}>Continue</button>
                    </div>
                </div>
            </Modal>
        );
    }

});

var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(modalActions, dispatch);
}

module.exports = ReactRedux.connect(null, mapDispatchToProps)(InterestedSuccessModal);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/interestedSuccessModal.jsx